import type { JournaledEventsConsumerDelegate, SyncEvent } from './types';
export class NoOpSyncDelegate implements JournaledEventsConsumerDelegate {
  async consume(_batch: readonly Readonly<SyncEvent>[]): Promise<Set<string>> {
    return new Set<string>();
  }
}